(() => {
  let pending = false;
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-clio-lube-add]');
    if (!button || pending) return;
    event.preventDefault();
    pending = true;
    const offer = button.closest('[data-clio-lube-offer]');
    const status = offer.querySelector('[data-clio-lube-status]');
    const inDrawer = Boolean(button.closest('cart-drawer'));
    status.textContent = status.dataset.loading;
    document.querySelectorAll('[data-clio-lube-add]').forEach((item) => { item.disabled = true; });
    const descriptors = [
      {id:'cart-icon-bubble',section:'cart-icon-bubble',selector:'.shopify-section'},
      {id:'CartDrawer',section:'cart-drawer',selector:'.drawer__inner'}
    ];
    for (const id of ['main-cart-items','main-cart-footer']) {
      const element = document.getElementById(id);
      if (element) descriptors.push({id,section:element.dataset.id,selector:'.js-contents'});
    }
    try {
      const response = await fetch(routes.cart_add_url, {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:[{id:Number(button.dataset.clioLubeAdd),quantity:1}],sections:descriptors.map((section)=>section.section),sections_url:window.location.pathname})
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || status.dataset.error);
      for (const descriptor of descriptors) {
        const target = document.getElementById(descriptor.id);
        const markup = data.sections?.[descriptor.section];
        if (!target || !markup) continue;
        const parsed = new DOMParser().parseFromString(markup,'text/html');
        const source = parsed.querySelector(descriptor.selector);
        const destination = target.querySelector(descriptor.selector) || target;
        if (source) destination.innerHTML = source.innerHTML;
      }
      const drawer = document.querySelector('cart-drawer');
      if (drawer) drawer.classList.remove('is-empty');
      if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate,{source:'cart-items',variantId:button.dataset.clioLubeAdd});
      const context = inDrawer ? drawer : document.querySelector('cart-items');
      const itemLink = context?.querySelector('a[href*="variant='+button.dataset.clioLubeAdd+'"]');
      if (itemLink) itemLink.focus();
    } catch (error) {
      status.textContent = error.message || status.dataset.error;
    } finally {
      pending = false;
      document.querySelectorAll('[data-clio-lube-add]').forEach((item)=>{item.disabled=false;});
    }
  });
})();
